import { Game } from "phaser";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { SplashScene } from "./SplashScene";

export class BrandingLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const background = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
        background.scaleX = GameVars.scaleX;
        this.add(background);

        if (GameVars.isMobile) {

            const aspectRatio = window.innerWidth / window.innerHeight;

            if (aspectRatio > 2.2) {
                background.scaleX = 1.25 * GameVars.scaleX;
                background.scaleY = 1.25;
            }
        }

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - 30);
        scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(scaledItemsContainer);

        const brandingCapsule = new Phaser.GameObjects.Image(this.scene, 0, 0, "branding_capsule");
        scaledItemsContainer.add(brandingCapsule);

        const brandingLabel = new Phaser.GameObjects.Text(this.scene, 0, 365, gameText.SCAND_WINTER_ED[lan], {fontFamily: "OpenSans-CondLight", fontSize: "45px", color: "#FFFFFF"});
        brandingLabel.alpha = 0;
        brandingLabel.setOrigin(.5),
        brandingLabel.setShadow(2, 2, "#000000", 6, true, true);

        scaledItemsContainer.add(brandingLabel);

        const gameLogo = new Phaser.GameObjects.Image(this.scene, 0, -275, "texture_atlas_1", "mahjong_at_home_title");
        gameLogo.setScale(0);
        scaledItemsContainer.add(gameLogo);

        this.scene.tweens.add({
            targets: gameLogo,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 1200,
            delay: 800
        });

        this.scene.tweens.add({
            targets: brandingLabel,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1200,
            delay: 1100,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    alpha: 0,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 600,
                    delay: 1200,
                    onComplete: () => {
                        SplashScene.currentInstance.removeBrandingLayer();
                    },
                    onCompleteScope: this
                });
            }
        });
    }
}
